import React from 'react';
import './domain-notification-settings.scss';
import classnames from 'classnames';
import DomainSettingsTab, {
    IDomainSettingsTab,
    IDomainSettingsTabState
} from '../abstract-domain-settings-tab/abstract-domain-settings-tab';
import { GeneralSettingsWell } from './general-settings-well';
import FallbackNotificationWell from './fallback-notification-well';
import { Flags } from '@pushly/aquarium-utils/lib/enums/flags';
import NotificationAutomationWell from './notification-automation-well';

interface IDomainNotificationSettings extends IDomainSettingsTab {
}

interface IState extends IDomainSettingsTabState {
}

class DomainNotificationSettings extends DomainSettingsTab<IDomainNotificationSettings, IState> {
    public render() {
        const { loading, domain } = this.state;

        let hasFallbackFlag = false;
        if (domain?.flags?.includes(Flags.domain.FEAT_DOMAIN_FALLBACK_NOTIFICATION.key)) {
            hasFallbackFlag = true;
        }

        let hasNotifFieldSuggestionsFlag = false;
        if (domain?.flags?.includes(Flags.domain.FEAT_NOTIF_FIELD_SUGGESTIONS.key)) {
            hasNotifFieldSuggestionsFlag = true;
        }

        return (
            <div className={classnames('domain-settings-tab', 'domain-notification-settings')}>
                <GeneralSettingsWell
                    loading={loading}
                    domain={domain!}
                    onDomainUpdated={this.handleDomainUpdated}
                />

                {hasNotifFieldSuggestionsFlag && (
                    <NotificationAutomationWell
                        domain={domain}
                        onDomainUpdated={this.handleDomainUpdated}
                    />
                )}

                {hasFallbackFlag && (
                    <FallbackNotificationWell
                        loading={loading}
                        domain={domain!}
                        onDomainUpdated={this.handleDomainUpdated}
                    />
                )}
            </div>
        );
    }
}

export default DomainNotificationSettings;
